import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';

import type {GetCustomFieldStagesets_stagesets as Stageset} from 'nutshell-graphql-types';

import {CustomFieldsPipelineTable} from './custom-fields-pipeline-table';
import {CustomFieldsSidebarSection} from './custom-fields-sidebar-section';
import {CustomFieldsTable} from './custom-fields-table';
import {useGetCustomFields} from './graphql/hooks';

// The names of the tabs in our URL
export const LEAD_TAB_NAME = 'lead';
export const COMPANY_TAB_NAME = 'company';
export const PERSON_TAB_NAME = 'person';

export type Tab = 'lead' | 'company' | 'person';

// The names of the tabs in our ViewTabs component
export const LEAD_VIEW_TAB_NAME = 'Lead';
export const COMPANY_VIEW_TAB_NAME = 'Company';
export const PERSON_VIEW_TAB_NAME = 'Person';

export const TAB_TITLE_MAP = {
    [LEAD_TAB_NAME]: LEAD_VIEW_TAB_NAME,
    [COMPANY_TAB_NAME]: COMPANY_VIEW_TAB_NAME,
    [PERSON_TAB_NAME]: PERSON_VIEW_TAB_NAME,
} as const;

export const TAB_GRAPHQL_MAP = {
    [LEAD_TAB_NAME]: 'LEAD',
    [COMPANY_TAB_NAME]: 'ACCOUNT',
    [PERSON_TAB_NAME]: 'CONTACT',
} as const;

type Props = {
    tab: string;
    isViewingArchived: boolean;
    selectedPipelineId: string | null | undefined;
    pipelines: Stageset[];
    onOpenCreateModal: () => void;
    onOpenEditModal: (fieldId: string) => void;
    onArchive: (fieldId: string) => void;
    onRestore: (fieldId: string) => void;
};

export function CustomFields(props: Props) {
    // @ts-expect-error
    const {customFields, isLoading} = useGetCustomFields(TAB_GRAPHQL_MAP[props.tab]);

    const activeFields = customFields ? customFields.active : [];
    const archivedFields = customFields ? customFields.archived : [];
    const customFieldsToShow = props.isViewingArchived ? archivedFields : activeFields;
    const pipeline = props.pipelines.find((pipe) => pipe.id === props.selectedPipelineId);

    return (
        <>
            <div className='flex flex-dir-col gap-16'>
                {isLoading && <LoadingPage />}
                {!isLoading && customFields && (
                    <div className='flex gap-16'>
                        <CustomFieldsSidebarSection
                            tab={props.tab}
                            isViewingArchived={props.isViewingArchived}
                            customFields={customFields}
                            selectedPipelineId={props.selectedPipelineId}
                            pipelines={props.pipelines}
                        />
                        {props.selectedPipelineId && pipeline ? (
                            <CustomFieldsPipelineTable
                                pipeline={pipeline}
                                onOpenCreateModal={props.onOpenCreateModal}
                                onOpenEditModal={props.onOpenEditModal}
                                onArchive={props.onArchive}
                            />
                        ) : (
                            <CustomFieldsTable
                                customFields={customFieldsToShow}
                                entityType={props.tab}
                                onOpenCreateModal={props.onOpenCreateModal}
                                onOpenEditModal={props.onOpenEditModal}
                                onArchive={props.onArchive}
                                onRestore={props.onRestore}
                                isViewingArchived={props.isViewingArchived}
                            />
                        )}
                    </div>
                )}
            </div>
        </>
    );
}
